module.exports = __webpack_public_path__ + "img/pic_photo.f4bf07e8.png";